module.exports = __webpack_public_path__ + "static/media/[Philm]2010-11-17.4750c61d.md";